import { getActivityList, getCouponList } from '@/api/fission'
import { stringToJson } from '@/utils/tool'
import { globalVariable } from '@/utils/exportVariable'
// import { getUvid } from '@/utils/uvid'
import { getQuery } from '@/utils/utils'

export const ACTIVITYTYPE = 5
let executeCount = 0

export const getAcitivityInfo = (update = false, queryType = 1) => {
  const { region = '', rankingActivityInfo = {} } = globalVariable.store.state
  const activitySource = getQuery('activitySource') || ''
  if (!update) {
    if (
      rankingActivityInfo &&
      Object.keys(rankingActivityInfo).length > 0 &&
      rankingActivityInfo.activityId
    ) {
      return Promise.resolve(rankingActivityInfo)
    }
  }
  return new Promise((resolve, reject) => {
    getActivityList({
      activityType: ACTIVITYTYPE,
      country: region,
      activitySource,
      queryOnline: queryType,
    })
      .then((res) => {
        if (res && res.length) {
          const activity =
            (res.filter((item) => item.activityType * 1 === ACTIVITYTYPE * 1) ||
              [])[0] || {}
          if (activity && activity.extraInfo) {
            activity.extraInfo = stringToJson(activity.extraInfo) || {}
          }
          const store = globalVariable?.store || {}
          store.commit('setRankingActivityInfos', activity)
          const { extraInfo = {} } = activity
          store.commit('setShareTitle', extraInfo.shareTitle || '')
          resolve(activity)
        } else {
          if (executeCount > 0) {
            return reject()
          }
          executeCount += 1
          // 如果没有上线的活动，则查全部的活动信息
          return getAcitivityInfo(false, 0)
            .then((res) => {
              resolve(res)
            })
            .catch((err) => {
              reject(err)
            })
        }
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export const getCouponInfos = (couponIdString) => {
  const { region = '' } = globalVariable.store.state

  return new Promise((resolve, reject) => {
    getCouponList({
      country: region,
      couponIdString,
    })
      .then((res) => {
        if (res) {
          resolve(res)
        } else {
          reject(null)
        }
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 格式化优惠券信息
export const formatCoupon = (coupon = {}) => {
  const res = { ...coupon }
  const { couponType, couponDiscount, couponPrice } = res || {}
  // couponType 1 立减券 2折扣券
  if (couponType * 1 === 1) {
    res.couponDisplayDiscount = couponPrice
  } else {
    res.couponDisplayDiscount = 100 - couponDiscount * 1
  }
  return res
}
// uvid末尾是否为奇数
export const uvidIsOdd = () => {
  // const lastChar = getUvid().slice(-1) || 0
  // return !(lastChar % 2 === 1)
  return false
}

export const covertNumber = (num, i18ntext_thousand, i18ntext_million) => {
  i18ntext_thousand = i18ntext_thousand ? i18ntext_thousand : '{pointsNum}K'
  i18ntext_million = i18ntext_million ? i18ntext_million : '{pointsNum}J'
  const existVar1 = i18ntext_thousand.indexOf('{pointsNum}') > -1
  const existVar2 = i18ntext_million.indexOf('{pointsNum}') > -1
  if (num >= 10000 && num < 1000000) {
    num = (num / 1000).toFixed(1)
    return existVar1
      ? i18ntext_thousand.replace('{pointsNum}', num)
      : `${num}${i18ntext_thousand}`
  } else if (num >= 1000000) {
    num = (num / 1000000).toFixed(1)
    return existVar2
      ? i18ntext_million.replace('{pointsNum}', num)
      : `${num}${i18ntext_million}`
  } else {
    return num
  }
}
